<!-- USed to view the mail sync report of organizaions
In (UI) System Admin-> Mail Synchronization-> Open any mail
-->
<template>
  <div class="px-4">
    <v-row class="mb-4 mt-6" no-gutters>
      <div class="pa-0">
        <v-icon @click="$router.go(-1)" class="pointer">arrow_back_ios</v-icon>
      </div>
      <div class="pa-0">
        <h2
          v-if="pageType !== $enums.mailSyncPageType.systemAdmin"
          class="line-28"
        >
          Mail Sync Report
        </h2>
        <h2 v-else class="line-28">Mail Sync Report</h2>
      </div>
    </v-row>
    <table class="information-table">
      <tbody>
        <tr>
          <td class="font700">Status</td>
          <td>{{ splitUnderscoreToCaptialise(executionData.status || '') }}</td>
        </tr>
        <tr>
          <td class="font700">Requested by</td>
          <td>
            {{ formatFullName(userIdNameMap[executionData.requestedBy]) }}
          </td>
        </tr>
        <tr>
          <td class="font700">Approved by</td>
          <td>
            {{
              formatFullName(userIdNameMap[executionData.approvedBy]) ||
                'Not yet approved'
            }}
          </td>
        </tr>
        <tr>
          <td class="font700">No. of synchronized users</td>
          <td>{{ executionData.processed }}</td>
        </tr>
      </tbody>
    </table>
    <x-table
      :columns="[...columns, ...extraColumns]"
      pageSizeOption="OPTION_2"
      :updateTableSize="updateTableRowCount"
      :headerFixed="true"
      :tableRows="
        userReports.slice(pageSize * (pageNumber - 1), pageSize * pageNumber)
      "
      :loading="tableLoading"
      :paginationData="{
        pageSize,
        pageNumber,
        totalRecords: userReports.length,
        setPage: changePage
      }"
    >
      <template slot="table_item" slot-scope="props">
        <tr v-for="(userReport, index) in props.tableRows" :key="index">
          <td>{{ userReport.readableName }}</td>
          <td>{{ numberINString(userReport.successfulMessages) }}</td>
          <td
            :class="{ clickable: canApproveMailSyncRequest }"
            @click="
              canApproveMailSyncRequest &&
                openFailureModal({
                  type: 'USER',
                  title: userReport.readableName,
                  rowSelected: userReport
                })
            "
          >
            {{ numberINString(userReport.failures) }}
          </td>
          <td v-for="(extraColumn, index) in extraColumns" :key="index">
            {{ userReport[extraColumn.label] }}
          </td>
        </tr>
        <tr v-if="props.tableRows.length">
          <td></td>
          <td>{{ numberINString(cumulative.success) }}</td>
          <td>
            <v-row no-gutters align="center">
              {{ numberINString(cumulative.failure) }}
              <v-icon
                v-if="canApproveMailSyncRequest"
                size="18"
                @click="
                  openFailureModal({
                    type: 'CUMULATIVE',
                    title: 'Total'
                  })
                "
                >info</v-icon
              >
            </v-row>
          </td>
          <td v-for="(extraColumn, index) in extraColumns" :key="index">
            <v-row no-gutters align="center">
              {{ numberINString(cumulative[extraColumn.label]) }}
              <v-icon
                v-if="canApproveMailSyncRequest"
                size="18"
                @click="
                  openFailureModal({
                    type: `CUMULATIVE_${extraColumn.label}`,
                    title: cumulative[extraColumn.label]
                  })
                "
                >info</v-icon
              >
            </v-row>
          </td>
        </tr>
      </template>
    </x-table>
    <x-dialog
      width="70%"
      :hasFixedHeader="true"
      @toggleModal="closeDialog"
      :dialogTitle="dialogProps.dialogTitle"
      :dialogState="dialogProps.dialogState"
    >
      <template slot="dialog_data" v-if="dialogProps.dialogState">
        <x-table
          :columns="failureTableColumns"
          :showPageSizeSelector="false"
          :showPagination="false"
          :tableRows="failureTableRows"
        >
          <template slot="table_item" slot-scope="props">
            <tr v-for="(failure, index) in props.tableRows" :key="index">
              <td>{{ failure.timestamp }}</td>
              <td>{{ failure.description }}</td>
              <td>{{ failure.stackTrace }}</td>
            </tr>
          </template>
        </x-table>
      </template>
    </x-dialog>
  </div>
</template>
<script>
import MailSyncService from '@/services/MailSyncService';
import {
  objectsForEach,
  splitUnderscoreToCaptialise,
  numberINString
} from '@/helpers/common';
export default {
  props: { pageType: String, title: String },
  data() {
    return {
      mailSyncId: this.$route.params.mailSyncId,

      tableLoading: true,
      pageSize: 5,
      pageNumber: 1,
      totalRecords: 0,
      userReports: [],
      fullReport: {},
      columns: [
        {
          label: 'User',
          field: 'orgName'
        },
        {
          label: 'Success'
        },
        {
          label: 'Failure'
        }
      ],
      failureTableColumns: [
        { label: 'DateTime' },
        { label: 'Description' },
        { label: 'Stack Trace' }
      ],
      extraColumns: [],
      cumulative: { success: 0, failure: 0 },
      dialogProps: {
        dialogTitle: '',
        dialogState: false,
        modalType: '',
        rowSelected: {}
      },
      executionData: {},
      // helper functions
      splitUnderscoreToCaptialise,
      numberINString
    };
  },
  computed: {
    // to load the failure report
    failureTableRows() {
      if (this.dialogProps.modalType === 'CUMULATIVE') {
        const failureReports = [];
        Object.values(this.fullReport).map(userReport =>
          failureReports.push(...userReport.failures)
        );

        return failureReports;
      } else if (this.dialogProps.modalType === 'USER') {
        return this.fullReport.find(
          syncId => syncId.id === this.dialogProps.rowSelected.id
        ).failures;
      } else {
        const failureReports = [];
        Object.values(this.fullReport).map(userReport =>
          failureReports.push(
            ...userReport.failures.filter(failure => {
              return (
                failure.description ===
                this.dialogProps.modalType.split('CUMULATIVE_')[1]
              );
            })
          )
        );

        return failureReports;
      }
    },
    // to check if mail sync requst can approve
    canApproveMailSyncRequest() {
      return this.$can('approve', 'mailsync_request');
    }
  },
  methods: {
    /**
     * to change the table page
     * @param {Number} pageNumber
     */
    changePage(pageNumber) {
      this.pageNumber = pageNumber;
    },
    /**
     * Updates table row count
     * emitted when table display count changes
     * @param {Number} pageSize
     */
    updateTableRowCount(pageSize) {
      this.changePage(1);
      this.pageSize = pageSize;
    },
    // to close dialog
    closeDialog() {
      this.dialogProps.dialogState = false;
    },
    /**
     * this opens the failure report in a modal
     * @param {String} title
     * @param {String} type
     * @param {Object} rowSelected
     */
    async openFailureModal({ title, type, rowSelected }) {
      const fullReportResponse = await MailSyncService.getMailSyncExecutionReport(
        this.mailSyncId
      );
      this.fullReport = objectsForEach(
        this.parseResponse(fullReportResponse)[0]?.report?.reports || {}
      );
      this.dialogProps.dialogTitle = title + ' failure report';
      this.dialogProps.modalType = type;
      this.dialogProps.rowSelected = rowSelected;
      this.dialogProps.dialogState = true;
    },

    // to get the mail sync data
    async getMailSyncExecution() {
      this.tableLoading = true;
      this.userReports = [];
      try {
        const executionResponse = await MailSyncService.getMailSyncExecution(
          this.mailSyncId
        );

        this.executionData = this.parseResponse(executionResponse)[0] || {};

        await this.addUserDetails([
          ...new Set([
            this.executionData.requestedBy,
            this.executionData.approvedBy
          ])
        ]);

        this.parseUserWiseReport(this.executionData.progress);

        this.tableLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * parse the execution report data
     * @param {Object} parsedfullReportResponse
     */
    parseUserWiseReport(parsedfullReportResponse) {
      const users = objectsForEach(parsedfullReportResponse || {});

      let userArr = [];

      let failureColumns = [];

      users.forEach(user => {
        const failuresDescritionArray = Object.keys(
          user.countByFailureType || {}
        );
        userArr.push({
          ...user,
          ...user.countByFailureType
        });

        this.cumulative['success'] += user.successfulMessages;
        this.cumulative['failure'] += user.failures;

        failureColumns.push(...failuresDescritionArray);
      });

      this.userReports = userArr;
      new Set(failureColumns).forEach(failureColumn => {
        this.cumulative[failureColumn] = userArr.reduce(
          (total, user) => user[failureColumn] + total,
          0
        );
        this.extraColumns.push({ label: failureColumn });
      });
    }
  },

  mounted() {
    this.getMailSyncExecution();
    if (
      !this.canApproveMailSyncRequest &&
      this.pageType === this.$enums.mailSyncPageType.systemAdmin
    ) {
      this.snackbar('error', this.$message.NO_PERMISSION);
      this.initalRoute('GO_TO_INITAL');
    }
  }
};
</script>
